export const BASE_CLASS = 'mt-MakesDistributor'
export const SPACE_STRING = ' '
export const LOW_DASH = '_'
